import styled, { keyframes } from 'styled-components'
import { vhToPx, hex2rgb, evalImage, responsiveDimension } from '@/utils'
import UpArrowIcon from '@/assets/images/preplay-up-arrow-black.webp'

let FONT_SIZE = '1.8vh'
const h = 6

const OptionInputsWrapper = styled.div`
  width: 20%;
  height: inherit;
  display: flex;
  justify-content: space-between;
`
const StarWrapper = styled.div`
  width: 3%;
  height: ${props => h}vh;
  position: relative;
`
const DDSelectType = styled.select`
  width: 7%;
  height: ${props => h}vh;
  background-color: #e5e5e5;
  outline: none;
  border: none;
  -webkit-appearance: none;

  background-image: url(${props => (props.locked ? null : UpArrowIcon)});
  background-repeat: no-repeat;
  background-position: bottom ${props => -0.5}vh right;
  background-size: ${props => 2}vh;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
  color: #000000;
  line-height: 1;
  text-transform: uppercase;
  text-align-last: center;
  user-select: text;
`
const PlayOrTimerWrapper = styled.div`
  width: 6%;
  height: inherit;
`

const AwardWrapper = styled.div`
  width: 20%;
  height: ${props => h}vh;
  position: relative;
`

module.exports = {
  OptionInputsWrapper,
  DDSelectType,
  StarWrapper,
  PlayOrTimerWrapper,
  AwardWrapper,
}



// WEBPACK FOOTER //
// src/Components/CommandHost/style.js